import { h } from 'preact';

export function RemixIcon(props: { icon: string, className?: string }) {
    return <i
        className={[props.icon, ...(props.className ? props.className.split(' ') : [])].join(' ')}
        />;
}